import {
  BasicButton,
  DangerButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  Stack,
  Text,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

type Props = {
  isOpen: boolean;
  isLoading: boolean;
  rubricName: string | null;
  onCancel: () => void;
  onConfirm: () => void;
};

export function DeactivateRubricModal(props: Props) {
  const { isOpen, isLoading, rubricName, onConfirm, onCancel } = props;
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen}>
      <Dialog>
        <DialogHeader onClose={props.onCancel}>
          {t("Deactivate rubric: {{ name }}?", { name: rubricName })}
        </DialogHeader>
        <DialogContent>
          <Stack>
            <Text style="global/body-primary">
              <Trans>
                By clicking “Deactivate rubric”, this rubric will be disabled
                and removed from all linked packages. It will no longer be used
                for scoring until reactivated.
              </Trans>
            </Text>
            <Text style="global/body-primary">
              <Trans>
                Cases already in progress will continue using this rubric. New
                cases created after deactivation will fall back to default
                scoring.
              </Trans>
            </Text>
          </Stack>
        </DialogContent>
        <DialogFooter>
          <BasicButton
            size="medium"
            onPress={onCancel}
            testID="cancel-deactivate-button"
          >
            <Trans>Cancel</Trans>
          </BasicButton>
          <DangerButton
            type="submit"
            size="medium"
            isLoading={isLoading}
            onPress={() => onConfirm()}
            testID="deactivate-rubric-confirm-button"
          >
            <Trans>Deactivate rubric</Trans>
          </DangerButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
